// src/features/platform/auth-providers.ts
// OAuth2 provider management logic for platform admins.
// Framework-agnostic — NO React imports.

export interface ProviderFormState {
  provider_name: string;
  provider_type: string;
  description: string;
  icon_url: string;
  client_id: string;
  client_secret: string;
  authorization_url: string;
  token_url: string;
  userinfo_url: string;
  scopes: string;
  enabled: boolean;
  priority: number;
}

export const EMPTY_PROVIDER_FORM: ProviderFormState = {
  provider_name: '',
  provider_type: 'custom',
  description: '',
  icon_url: '',
  client_id: '',
  client_secret: '',
  authorization_url: '',
  token_url: '',
  userinfo_url: '',
  scopes: '',
  enabled: false,
  priority: 0,
};

export const PROVIDER_TYPES = [
  { value: 'google', labelKey: 'platform.authProviders.typeGoogle' },
  { value: 'yandex', labelKey: 'platform.authProviders.typeYandex' },
  { value: 'github', labelKey: 'platform.authProviders.typeGithub' },
  { value: 'microsoft', labelKey: 'platform.authProviders.typeMicrosoft' },
  { value: 'custom', labelKey: 'platform.authProviders.typeCustom' },
] as const;

export function validateProviderForm(data: ProviderFormState): Record<string, string> {
  const errors: Record<string, string> = {};
  if (!data.provider_name.trim()) errors.provider_name = 'platform.authProviders.nameRequired';
  if (!data.client_id.trim()) errors.client_id = 'platform.authProviders.clientIdRequired';
  if (!data.authorization_url.trim()) errors.authorization_url = 'platform.authProviders.authUrlRequired';
  if (!data.token_url.trim()) errors.token_url = 'platform.authProviders.tokenUrlRequired';
  if (!data.userinfo_url.trim()) errors.userinfo_url = 'platform.authProviders.userinfoUrlRequired';
  return errors;
}

export function scopesStringToList(scopes: string): string[] {
  return scopes.split(/[,\s]+/).map(s => s.trim()).filter(Boolean);
}

export function scopesListToString(scopes: string[] | undefined): string {
  return (scopes ?? []).join(', ');
}
